import React, { useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import "../../styles/book.css"; // Import your CSS file for styling

interface PageProps {
  number: number;
  children: React.ReactNode;
}

const Page = React.forwardRef<HTMLDivElement, PageProps>(
  ({ number, children }, ref) => {
    return (
      <div className="page" ref={ref}>
        <div className="page-content">
          <div className="page-header">Page {number}</div>
          <div className="page-body">{children}</div>
        </div>
      </div>
    );
  }
);

Page.displayName = "Page";

interface FlipBookComponentProps {
  images: string[]; // Array of image sources
}

const FlipBookComponent: React.FC<FlipBookComponentProps> = ({ images }) => {
  const bookRef = useRef<any>(null);

  return (
    <div className="book-container">
      <HTMLFlipBook
        width={595}
        height={842}
        size="stretch"
        minWidth={315}
        maxWidth={500}
        minHeight={400}
        maxHeight={1533}
        maxShadowOpacity={0.5}
        showCover={true}
        mobileScrollSupport={true}
        ref={bookRef}
        className="book"
        style={{ margin: "0 auto" }}
        startPage={0}
        drawShadow={false}
        flippingTime={1000}
        usePortrait={false}
        startZIndex={0}
        autoSize={true}
        clickEventForward={true}
        useMouseEvents={true}
        swipeDistance={30}
        showPageCorners={true}
        disableFlipByClick={false}
      >
        {images.map((src, index) => (
          <Page key={index} number={index + 1}>
            <img src={src} alt={`Page ${index + 1}`} style={{ width: "100%", height: "100%" }} />
          </Page>
        ))}
      </HTMLFlipBook>
    </div>
  );
};

export default FlipBookComponent;